var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 158,
    viewBox: "0 0 128 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_252_3325)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.914 145.757C100.914 141.721 97.6438 138.452 93.6096 138.452H30.6205C26.5861 138.452 23.3159 141.721 23.3159 145.757C23.3159 149.791 26.5861 153.062 30.6205 153.062H93.6096C97.6438 153.062 100.914 149.791 100.914 145.757Z",
    fill: "#8FA3BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7031 117.911H95.5279V146.527H28.7031V117.911Z",
    fill: "#0A2445"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5396 123.233H81.6909V140.766H42.5396V123.233Z",
    fill: "#C1A57B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1004 137.976H78.1296V125.754H46.1004V137.976ZM78.6937 139.105H45.5363C45.2248 139.105 44.9722 138.851 44.9722 138.54V125.19C44.9722 124.879 45.2248 124.626 45.5363 124.626H78.6937C79.0052 124.626 79.2579 124.879 79.2579 125.19V138.54C79.2579 138.851 79.0052 139.105 78.6937 139.105Z",
    fill: "#A36D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7034 114.294C28.9115 108.376 47.8701 107.132 62.1137 97.5815C76.448 108.35 95.3172 108.39 95.5247 114.294H95.5263V117.887H28.7017V114.294H28.7034Z",
    fill: "#A36D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5075 114.906H33.7209C33.4686 114.906 33.2642 114.702 33.2642 114.45C33.2642 114.197 33.4686 113.993 33.7209 113.993H90.5075C90.7599 113.993 90.9644 114.197 90.9644 114.45C90.9644 114.702 90.7599 114.906 90.5075 114.906Z",
    fill: "#DCC198"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4922 79.1925C53.4922 79.1925 55.4022 82.0526 56.9909 87.1095C57.5099 88.7629 58.0383 90.5148 58.0203 92.3879C58.002 94.2757 57.4134 96.0019 56.8835 97.6659C55.2902 102.667 53.4922 105.583 53.4922 105.583C53.4922 110.342 70.7361 110.342 70.7361 105.583C70.7361 105.583 68.9387 102.667 67.3454 97.6659C66.8149 96.0019 66.2269 94.2757 66.2083 92.3879C66.19 90.5148 66.7188 88.7629 67.238 87.1095C68.8267 82.0526 70.7361 79.1925 70.7361 79.1925C70.7361 74.4335 66.873 70.5704 62.1142 70.5704C57.3559 70.5704 53.4922 74.4335 53.4922 79.1925Z",
    fill: "#DCC198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1957 59.3594C19.2637 59.3594 13.5399 58.1039 8.90818 54.5079C3.26365 50.1254 0.27188 43.2989 0.0156229 34.2182C-0.202033 26.5041 1.85548 21.0142 6.1312 17.9013C12.7643 13.0714 21.9631 16.2474 22.3514 16.385C23.8437 16.9143 24.6251 18.552 24.0963 20.044C23.5687 21.534 21.9351 22.315 20.4453 21.7918C20.3467 21.7579 13.6523 19.4969 9.48796 22.5485C6.84417 24.4862 5.58524 28.3579 5.74634 34.0565C5.95176 41.3416 8.19846 46.6989 12.4239 49.9796C17.4724 53.8993 24.3549 54.1397 28.7149 53.1548C30.2587 52.8054 31.7936 53.7749 32.1425 55.3191C32.4915 56.8631 31.5224 58.3978 29.9782 58.7467C28.2989 59.126 26.3203 59.3592 24.1957 59.3594Z",
    fill: "#DCC198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8041 59.3594C97.6789 59.3594 95.7013 59.1262 94.0216 58.7467C92.4773 58.3978 91.5083 56.8631 91.8572 55.3191C92.2062 53.7749 93.7407 52.8064 95.2849 53.1548C99.6445 54.14 106.527 53.8993 111.576 49.9797C115.801 46.6989 118.048 41.3416 118.253 34.0567C118.414 28.3579 117.156 24.4862 114.512 22.5485C110.338 19.4897 103.621 21.7686 103.554 21.7919C102.061 22.3098 100.427 21.5246 99.9046 20.0341C99.382 18.5436 100.159 16.9124 101.648 16.385C102.037 16.2474 111.236 13.0714 117.869 17.9013C122.144 21.0142 124.202 26.5041 123.984 34.2184C123.728 43.2989 120.736 50.1254 115.091 54.5079C110.46 58.1035 104.736 59.3592 99.8041 59.3594Z",
    fill: "#DCC198"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8892 20.1389V8.60085C18.8892 3.85027 22.7391 0.00164795 27.4882 0.00164795H96.5104C98.7905 0.00164795 100.978 0.907425 102.591 2.52025C104.203 4.13308 105.109 6.31919 105.109 8.60085C105.109 14.1521 105.109 20.3445 105.109 20.3445C105.032 55.3176 85.7449 83.6719 61.9992 83.6719C38.2065 83.6719 18.8892 55.2039 18.8892 20.1389Z",
    fill: "#A36D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8809 19.8054C74.0485 19.8054 83.9122 29.6691 83.9122 41.8364C83.9122 54.0037 74.0485 63.8672 61.8809 63.8672C49.7138 63.8672 39.8501 54.0037 39.8501 41.8364C39.8501 29.6691 49.7138 19.8054 61.8809 19.8054Z",
    fill: "#C1A57B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8814 17.2888C48.3464 17.2888 37.3348 28.3004 37.3348 41.8353C37.3348 55.3703 48.3464 66.3818 61.8814 66.3818C75.4165 66.3818 86.4281 55.3703 86.4281 41.8353C86.4281 28.3004 75.4165 17.2888 61.8814 17.2888ZM61.8814 67.5312C47.7125 67.5312 36.1855 56.0041 36.1855 41.8353C36.1855 27.6665 47.7125 16.1401 61.8814 16.1401C76.0502 16.1401 87.5774 27.6665 87.5774 41.8353C87.5774 56.0041 76.0502 67.5312 61.8814 67.5312Z",
    fill: "#DCC198"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.063 29.8899C61.1784 29.5356 61.5078 29.2962 61.8805 29.2962C62.2531 29.2962 62.5835 29.5356 62.6987 29.8899C63.5422 32.4865 64.8 36.3583 65.2778 37.8268C65.3924 38.1817 65.7226 38.4211 66.0954 38.4211C67.6399 38.4211 71.7105 38.4211 74.4403 38.4211C74.813 38.4211 75.1434 38.6613 75.2586 39.0156C75.374 39.3697 75.2477 39.7582 74.9461 39.9772C72.7377 41.5816 69.4442 43.9743 68.1946 44.882C67.8929 45.101 67.7673 45.4893 67.882 45.8436C68.3597 47.3129 69.6175 51.1837 70.461 53.7802C70.5762 54.1345 70.4501 54.5228 70.1485 54.742C69.8474 54.961 69.4394 54.961 69.1377 54.742C66.9294 53.1368 63.6359 50.7442 62.3863 49.8365C62.0846 49.6175 61.6766 49.6175 61.3754 49.8365C60.1261 50.7442 56.8323 53.1368 54.6241 54.742C54.3223 54.961 53.9143 54.961 53.6126 54.742C53.3116 54.5228 53.1855 54.1345 53.3007 53.7802C54.1442 51.1837 55.402 47.3129 55.8792 45.8436C55.9944 45.4893 55.8683 45.101 55.5671 44.882C54.3176 43.9743 51.0241 41.5816 48.8158 39.9772C48.514 39.7582 48.3879 39.3697 48.5031 39.0156C48.6186 38.6613 48.9482 38.4211 49.3206 38.4211C52.0512 38.4211 56.1213 38.4211 57.6665 38.4211C58.0389 38.4211 58.3687 38.1817 58.484 37.8268C58.9617 36.3583 60.2195 32.4865 61.063 29.8899Z",
    fill: "#A36D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1061 52.8438C31.4354 52.8438 30.7975 52.4497 30.5185 51.7933C22.9955 34.0935 23.7798 17.3264 23.8168 16.6214C23.8667 15.6698 24.679 14.9379 25.6294 14.9895C26.5804 15.0392 27.3108 15.8513 27.2607 16.803C27.25 17.0191 26.5051 33.534 33.6924 50.4444C34.065 51.3207 33.6564 52.3333 32.7799 52.7058C32.5598 52.7994 32.3312 52.8438 32.1061 52.8438Z",
    fill: "#C1A57B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8519 66.4766C39.3247 66.4766 38.8045 66.2358 38.4661 65.7802C36.6668 63.3577 35.0004 60.742 33.5133 58.0058C33.0585 57.169 33.3683 56.1222 34.2051 55.6674C35.0417 55.2128 36.0889 55.5221 36.5437 56.3591C37.9534 58.9534 39.5317 61.4311 41.2347 63.7237C41.8026 64.4882 41.6432 65.5685 40.8787 66.1362C40.5697 66.3659 40.2093 66.4766 39.8519 66.4766Z",
    fill: "#C1A57B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.893 4.74342C107.893 2.12544 105.77 0.0024004 103.151 0.0024004C87.3259 0.0024004 36.4378 0.0024004 20.6123 0.0024004C17.9934 0.0024004 15.8701 2.12544 15.8701 4.74342C15.8701 4.74533 15.8701 4.74534 15.8701 4.74534C15.8701 7.36523 17.9934 9.48828 20.6123 9.48828C36.4378 9.48828 87.3259 9.48828 103.151 9.48828C105.77 9.48828 107.893 7.36523 107.893 4.74534C107.893 4.74534 107.893 4.74533 107.893 4.74342Z",
    fill: "#C1A57B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.718 5.57031H23.5116C23.0556 5.57031 22.686 5.19959 22.686 4.74479C22.686 4.28807 23.0556 3.91926 23.5116 3.91926H100.718C101.174 3.91926 101.544 4.28807 101.544 4.74479C101.544 5.19959 101.174 5.57031 100.718 5.57031Z",
    fill: "#A36D1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_252_3325",
    x: 0,
    y: 0,
    width: 128,
    height: 157.062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_252_3325"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_252_3325",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThird);
export default __webpack_public_path__ + "static/media/third.c9d2af0c3a53d7bd8c33cbd91dcfc5fd.svg";
export { ForwardRef as ReactComponent };